/**
 * category-select.tsx — dropdown danh mục giao dịch từ DANH SÁCH ĐÓNG được
 * quản trị (financeCategories, D43). Không còn tạo danh mục từ form giao dịch
 * — chống bùng nổ danh mục khi scale; thêm/sửa/ẩn ở "Quản lý danh mục"
 * (finance-categories-modal, mở từ thanh action Tài chính).
 */
import type { LifeOsState, TransactionType } from "../types";
import { activeFinanceCategoryNames } from "./finance-categories";
import { BentoSelect } from "./bento-ui";

/** Options cho dropdown theo loại giao dịch (đã lọc danh mục ẩn). */
export function categoryOptionsFor(
  state: Pick<LifeOsState, "financeCategories">,
  kind: TransactionType,
): string[] {
  return activeFinanceCategoryNames(state, kind);
}

export function CategorySelect({
  value,
  onChange,
  options,
  className = "",
}: {
  value: string;
  onChange: (v: string) => void;
  options: string[];
  className?: string;
}) {
  // Giao dịch cũ có danh mục không còn trong danh sách (đã xoá/ẩn) → vẫn hiển
  // thị được giá trị hiện tại, đánh dấu (cũ) để gợi ý chuyển sang danh mục chuẩn.
  const stale = value !== "" && !options.some((o) => o.toLowerCase() === value.toLowerCase());

  return (
    <BentoSelect
      className={`py-2.5 text-[14px] ${className}`}
      value={value}
      onChange={(e) => onChange(e.target.value)}
    >
      <option value="">— Chọn danh mục —</option>
      {stale && <option value={value}>{value} (cũ)</option>}
      {options.map((o) => (
        <option key={o} value={o}>{o}</option>
      ))}
    </BentoSelect>
  );
}
